/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition } from './get-zeus-organization-identity-verifications-for-president200-response-inner-antisocial-forces-check-inner-condition';
// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner } from './get-zeus-organization-identity-verifications-for-president200-response-inner-antisocial-forces-check-inner-results-inner';

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'category': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum;
    /**
     * 
     * @type {GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'condition'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCondition;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'organizationIdentityVerificationId': string;
    /**
     * 
     * @type {number}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'payloadDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'payloadId': string;
    /**
     * 
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'results'?: Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerResultsInner>;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInner
     */
    'status': string;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum = {
    company: 'company',
    customer: 'customer'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerAntisocialForcesCheckInnerCategoryEnum];


